import { FormattedMessage } from 'react-intl';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import {
  DATE_FORMAT,
  FieldWrapperVerticalV2,
  ReadOnly,
  useUserAccess,
} from '@ui-framework/index';
import DispatchMap from './DispatchMap';
import DispatchStatus from '../../../../DispatchStatus';
import { TimeSlotTypeChipWithAfterBeforeHours } from '../../../../TimeSlotTypeChip';

function DispatchDetails({ dispatch, serviceJob, assignedServiceProvider }) {
  const userAccess = useUserAccess();
  const { serviceProviderLocation } = serviceJob;

  const getAppointmentDate = () => {
    if (serviceJob?.appointmentDate) {
      return (
        <Box>
          {serviceJob?.appointmentDate && (
            <Box>
              <ReadOnly>{serviceJob?.appointmentDate}</ReadOnly>
            </Box>
          )}
          <Box>
            <TimeSlotTypeChipWithAfterBeforeHours
              code={serviceJob?.slotTypeCode}
              afterHour={serviceJob?.appointmentArrivalStartTime}
              beforeHour={serviceJob?.appointmentArrivalEndTime}
              direction="column"
              smallAfterAndBefore
            />
          </Box>
        </Box>
      );
    }
    return <Box>&ndash; </Box>;
  };

  const getServiceProviderLocation = () => {
    if (serviceProviderLocation?.locationName) {
      return <Box>{serviceProviderLocation?.locationName} </Box>;
    }
    return <Box>&ndash; </Box>;
  };

  const detailsField = {
    name: 'dispatch_details',
    label: {
      localeId: 'DISPATCH_DETAILS',
      defaultMessage: 'Dispatch Details',
    },
    control: 'subsection',
  };

  const fields = [
    ...(userAccess.isSA() || userAccess.isAdmin()
      ? [
          {
            name: 'service_provider',
            label: {
              localeId: 'SERVICE_PROVIDER',
              defaultMessage: 'Service Provider',
            },
            control: 'text',
            value: assignedServiceProvider?.name || 'Not Assigned',
          },
        ]
      : []),
    {
      name: 'service_provider_location',
      label: {
        localeId: 'LOCATION',
        defaultMessage: 'Location',
      },
      control: 'text',
      value: getServiceProviderLocation(),
    },
    {
      name: 'dispatch_number',
      label: {
        localeId: 'DISPATCH_NUMBER',
        defaultMessage: 'Dispatch Number',
      },
      control: 'text',
      value: dispatch?.dispatchNumber,
    },

    {
      name: 'appointment_window',
      label: {
        localeId: 'APPOINTMENT_WINDOW',
        defaultMessage: 'Appointment Window',
      },
      control: 'AppointmentWindow',
      value: getAppointmentDate(),
    },
    ...(userAccess.isSA() || userAccess.isAdmin()
      ? [
          {
            name: 'dispatch_details',
            label: {
              localeId: 'DISPATCH_STATUS',
              defaultMessage: 'Dispatch Status',
            },
            control: 'DispatchStatus',
            value: dispatch?.status || '',
          },
        ]
      : []),
    {
      name: 'dispatch_created_date',
      label: {
        localeId: 'CREATED_DATE',
        defaultMessage: 'Created Date',
      },
      control: 'text',
      value: dispatch.createdDateTime
        ? dayjs(dispatch.createdDateTime).format(DATE_FORMAT.LONG_DATE)
        : '',
    },
    {
      name: 'dispatch_lastModified_date',
      label: {
        localeId: 'LAST_MODIFIED_DATE',
        defaultMessage: 'Last Modified Date',
      },
      control: 'text',
      value: dispatch.lastModifiedDateTime
        ? dayjs(dispatch.lastModifiedDateTime).format(DATE_FORMAT.LONG_DATE)
        : '',
    },
  ];

  const Mapfields = {
    name: 'dispatch_map',
    label: {
      localeId: 'DISPATCH_STATUS',
      defaultMessage: 'Dispatch Status',
    },
    value: serviceJob.id,
  };

  return (
    <FieldWrapperVerticalV2
      key={detailsField?.name}
      field={detailsField}
      errors={[]}>
      {!dispatch?.id ? (
        <Grid2 container sx={{ m: 1 }}>
          <Typography>
            <FormattedMessage
              id="NO_DISPATCH_INFORMATION_TO_DISPLAY"
              defaultMessage="No dispatch information to display"
            />
          </Typography>
        </Grid2>
      ) : (
        <Grid2 container>
          <Grid2 xs={11} columnSpacing={10} container>
            {fields.map(f => {
              let control = null;
              switch (f.control) {
                case 'DispatchMap':
                  control = (
                    <Box textAlign="right">
                      <DispatchMap value={f.value} key={f.name} />
                    </Box>
                  );
                  break;
                case 'DispatchStatus':
                  control = (
                    <FieldWrapperVerticalV2 key={f.name} field={f} errors={[]}>
                      <DispatchStatus value={f.value} key={f.name} />
                    </FieldWrapperVerticalV2>
                  );
                  break;
                case 'AppointmentWindow':
                  control = (
                    <FieldWrapperVerticalV2 key={f.name} field={f} errors={[]}>
                      {f.value}
                    </FieldWrapperVerticalV2>
                  );
                  break;
                default:
                  control = (
                    <FieldWrapperVerticalV2 key={f.name} field={f} errors={[]}>
                      <Box>
                        <ReadOnly>{f.value}</ReadOnly>
                      </Box>
                    </FieldWrapperVerticalV2>
                  );
              }
              return (
                <Grid2 xs={12 / fields.length} key={f.name}>
                  {control}
                </Grid2>
              );
            })}
          </Grid2>
          <Grid2 xs={1} key={Mapfields.name}>
            <Box textAlign="right">
              <DispatchMap value={Mapfields.value} key={Mapfields.name} />
            </Box>
          </Grid2>
        </Grid2>
      )}
    </FieldWrapperVerticalV2>
  );
}

export default DispatchDetails;
